// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__14TXb","choiceBoxes":"toolbarselects_choiceBoxes__38GU1","simpleField":"toolbarselects_simpleField__2ITzE"};